import React, { useState, useEffect  } from "react";
import { Table, Button } from "reactstrap";
import AddressModal from "../components/AddressModal";
import {USER_ADDRESS_COLUMNS} from "../components/columns";
import { useTable, usePagination } from "react-table";
import { getUserAddress } from '@/shared/apiHelper'
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
const PAGE_SIZE = 10;
const UserAddresses = ({ userId, onAdd, onEdit, onDelete }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [addresses, setAddresses] = useState([]); // 🔥 Keep in local state

  const [selectedAddress, setSelectedAddress] = useState(null);
 const [count, setCount] = useState(0);
  const toggleModal = () => setModalOpen(!isModalOpen);
    // 🔥 Fetch addresses whenever pageIndex changes
  const fetchAddresses = async (pageIndex) => {
    try {
      const data = await getUserAddress(userId, pageIndex, PAGE_SIZE);
      setAddresses(data.results); // 🔥 Update addresses state
      setCount(data.count);
    } catch (err) {
      console.error("Error fetching addresses", err);
    }
  };
  let final_columns = [
      ...USER_ADDRESS_COLUMNS,
      ...[
        {
            Header: "Action",
            accessor: "action",
            Footer: "Action",
            minWidth: 250,
            width: 250,
            maxWidth: 250,
          Cell: ({ row }) => <RenderActions row={row} />,
        },
      ],
    ];
const columns = React.useMemo(() => final_columns, []);
   const tableInstance = useTable({
          columns,
          data: addresses,
          initialState: {
              pageIndex: 0,
              pageSize: 10,
          },
          manualPagination: true,
          pageCount: Math.ceil(count / PAGE_SIZE),
          autoResetSortBy: false,
          autoResetExpanded: false,
          autoResetPage: false,
      }, usePagination);
  const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        selectedFlatRows,
        state: { pageIndex, pageSize },
      } = tableInstance;
  const handleAdd = () => {
    setSelectedAddress(null);
    setModalOpen(true);
    console.log(isModalOpen);
  };

  const handleEdit = (addr) => {
    setSelectedAddress(addr);
    setModalOpen(true);
  };
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure to delete this Address?")) {
      await onDelete?.(id);
      fetchAddresses(pageIndex); // 🔥 Refresh table after delete
    }
  };
  const handleSubmit = async (data) => {
    if (data.id) {
      await onEdit?.(data);
    } else {
      await onAdd?.(data);
    }
    fetchAddresses(pageIndex); // 🔥 Refresh table after add/edit
  };
  // 🔥 Load addresses on mount & page change
  useEffect(() => {
    if (userId) {
      fetchAddresses(pageIndex);
    }
  }, [pageIndex, userId]);
   const RenderActions = ({ row }) => {
      return (
        <>
        {onEdit && (
                    <Button
                      size="sm"
                      color="warning"
                      className="me-2 m-0 mr-3"
                      onClick={() => handleEdit(row.original)}
                    >
                      Edit
                    </Button>
                  )}
                  {onDelete && (
                    <Button
                      size="sm"
                      color="danger"
                      className="m-0"
                      onClick={() => handleDelete(row.original.id)}
                    >
                      Delete
                    </Button>
                  )}
                  </>
      );
    };
  return (
  <>
    <h5>User Addresses</h5>

    {addresses.length > 0 ? (
      <Table size="md" {...getTableProps()}>
        <thead>
          <tr>
            <td colSpan={columns.length} className="title">
              <strong>User Addresses</strong>
            </td>
          </tr>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps({ key: undefined })}>
              {headerGroup.headers.map((column) => (
                <th
                  key={column.id}
                  {...column.getHeaderProps({ key: undefined })}
                  style={{
                    width: column.width,
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth,
                  }}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="table table--bordered" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
    ) : (
      <p>No addresses available.</p>
    )}

    <div className="my-3 status">
      {rows.length > 0 && (
        <ReactTablePagination
          page={page}
          gotoPage={gotoPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageOptions={pageOptions}
          pageSize={pageSize}
          pageIndex={pageIndex}
          pageCount={pageCount}
          setPageSize={setPageSize}
          manualPageSize={[]}
          dataLength={count}
        />
      )}
    </div>

    {onAdd && (
      <Button color="primary" onClick={handleAdd}>
        Add Address
      </Button>
    )}

    <AddressModal
      isOpen={isModalOpen}
      toggle={toggleModal}
      address={selectedAddress}
      onSubmit={handleSubmit}
    />
  </>
);

};

export default UserAddresses;
